const createRoutes = () => [
    {
        path: '/shlomo',
        component: require('./pages/ShlomoRaveParty').default,
    },
];
export default createRoutes;
